export enum AxiomReportType {
  RV = 'RV',
  GFPA = 'GFPA',
  GFPAH = 'GFPAH',
  GFR = 'GFR',
  MENU = 'MENU',
  SCEN = 'SCEN',
  OPTIM = 'OPTIM',
}

export enum AxiomReportTypeFullNames {
  RV = 'Brinson (Returns Variance) Attribution',
  GFPAH = 'Historical Scenario',
  GFPA = 'Global Factor Performance Attribution',
  GFR = 'Global Factor Risk',
  MENU = 'Menu',
  SCEN = 'Scenario / Shock Analysis',
  OPTIM = 'Optimizer',
}

export enum ColumnAggMethod {
  NONE = 'None',
  SUM = 'Sum',
  AVG = 'Average',
}

export enum ColumnFormat {
  TEXT = 'Text',
  NUM = 'Number',
  DATE = 'Date',
  CUR = 'Currency',
  PER = 'Percentage',
  BSP = 'Basis Points',
}

export enum AgGridCellValueMethod {
  VALUE_GETTER = 'getter',
  VALUE_FORMATTER = 'formatter',
}

export enum AxiomReportStatus {
  COMPLETED = 'Completed',
  FAILED = 'Failed',
  RUNNING = 'Running',
}

export enum ModuleTypePageTitle {
  REPORTING = 'Reporting',
  SCENARIO_BUILDER = 'Report Builder',
  PORTFOLIO_OPTIMIZATION = 'Portfolio Optimization',
  OPTIMIZATION_REPORTS = 'Reports',
  WHAT_IF_REPORTS = 'What-If',
  FACTOR_ANALYTICS = 'Factor Analytics',
}
